/**
 * Created by Amit Panghal.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {TractorBeamParsedGameData} from "../../server/data/TractorBeamParsedGameData";
import {TractorBeamGameConfig} from "../../TractorBeamGameConfig";
import {TractorBeamGameModuleConfig} from "../../TractorBeamGameModuleConfig";
import {TractorBeamSoundConfig} from "../../TractorBeamSoundConfig";
import {TractorBeamReelAttentionView} from "./TractorBeamReelAttentionView";

export class ReelAttentionEvent extends SpinReelEvent {
    public static readonly REEL_ATTENTION_PLAYING:string = "reelAttentionEvent_reelAttentionPlaying";
    public static readonly REEL_ATTENTION_STOPPING:string = "reelAttentionEvent_reelAttentionStopping";
}

export class TractorBeamReelAttentionController extends ReelStopPresentationController {

    private _nearWinReels:boolean[];
    private _scatterPositions:number[];
    private _gameMode:string;
    private _tractorData:TractorBeamParsedGameData;
    private _view:TractorBeamReelAttentionView;
    private _soundPlaying:boolean = false;
    private _isRandomStack:boolean = false;
    private _randomStackedOverlayReels:boolean [];
    private _totalWin:number = 0;
    private _firstReelPlaying:boolean = false;

    private _lastSpinningReel:number = 4;
    private _isRunningOnStack:boolean = false;
    private _delayedReel:IReelStoppedData | null;
    private _delayedReels:IReelStoppedData [] = [];

    private _reelZeroDone:boolean = false;
    private _quirkDelay:boolean = false;

    constructor(index:number) {
        super(index, "ReelStopAttention");

        this._view = new TractorBeamReelAttentionView();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:SpinEvent) => this.onBeforeSpinStart());

        // SPIN STOP STARTED
        // REEL_STOP_SPIN_STARTED
        //EventHandler.addEventListener(this, ReelEvent.REEL_STOP_SPIN_STARTED, (event:GameEvent) => this.onReelStopStarted(event.params[0]))
        //EventHandler.addEventListener(this, ReelEvent.REEL_ON_NEAR_WIN, (event:GameEvent) => this.justPlayAttention(event.params[0]));
    }

    private onBeforeSpinStart():void {
        for(let i = 0; i < TractorBeamGameConfig.instance.REELS_NUM; i++) {
            EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REMOVE_SLOW_ATTENTION_SPIN_SYMBOL_FROM_REEL, i, ReelSymbolName.SCATTER));
        }
    }

    protected parseFeatureGameData(data:TractorBeamParsedGameData):void {
        this._quirkDelay = false;
        this._reelZeroDone = false;
        this._isRunningOnStack = false;
        this._delayedReel = null;
        this._delayedReels.length = 0;
        this._totalWin = data.totalWin;
        this._isRandomStack = data.randomStackedTriggered;
        this._randomStackedOverlayReels = data.randomStackedOverlayReels;
        this._soundPlaying = false;
        this._tractorData = data;
        this._nearWinReels = data.nearWinReels != null ? data.nearWinReels : ArrayHelper.initArrayWithValues<boolean>(GameConfig.instance.REELS_NUM, (index:number) => {return false});
        this._scatterPositions = data.scatterPositions != null ? data.scatterPositions : ArrayHelper.initArrayWithValues<number>(GameConfig.instance.REELS_NUM, () => {return -1});
        this.calculateLastSpinningReel();
        this._firstReelPlaying = false;
    }

    calculateLastSpinningReel():void {
        this._randomStackedOverlayReels.forEach((bool:boolean, index:number) => {
            if(!bool) {
                this._lastSpinningReel = index;
            }
        });
    }

    public tryPlayAttentionReelZero():void {
        if(this._isRandomStack && this._nearWinReels[0] && !this._randomStackedOverlayReels[0]) {
            this._firstReelPlaying = true;
            this._isRunningOnStack = true;


            this.playAttention({
                reelId : 0,
                quickStop : false,
                fastSpin : false,
                active : true
            }, true);
            this._reelZeroDone = true;


            //console.log("------------------------------------------ ATTENTION REELS (R STACK) ---------------------------------------------");
            //console.log(this._nearWinReels);
            //console.log("\n \n \n \n \n \n ");
        }
    }

    onReelSpinStopped(data:IReelStoppedData):void {
        if(!data.quickStop && data.reelId === 0) {
            this._reelZeroDone = true;

            if(this._randomStackedOverlayReels[data.reelId] && this._nearWinReels[2]) {
                /*this.playAttention({
                    reelId: 1,
                    quickStop: false,
                    fastSpin: false,
                    active: true
                }, true);
                this._quirkDelay = true;*/
            }
        }
    }

    private onReelStopStarted(reelId:number):void {
        if(!this._randomStackedOverlayReels[reelId] && this._nearWinReels[reelId]) {
            console.log("on reel stop started: " + reelId);
            //this.justPlayAttention(reelId);
        }
    }

    public onReelBounce(data:IReelStoppedData):void {
        let attentionPlayed:boolean = false;

        if(data.reelId === 0) {
            this._reelZeroDone = true;
        }
        // STOPPING active reel
        EventHandler.dispatchEvent(new GameEvent(ReelAttentionEvent.REEL_ATTENTION_STOPPING, data.reelId));
        if(this._delayedReels.length > 0 /*&& !this._randomStackedOverlayReels[data.reelId]*/) {

            let shifter = this._delayedReels[0];
            if(shifter) {
                this.playAttention(shifter, undefined, (this._quirkDelay) ? 0.35 : 0, true);
                this._quirkDelay = false;
                attentionPlayed = true;
            }
            this._delayedReel = null;
        }

        if(/*data.reelId !== 4 &&*/ this._nearWinReels[data.reelId + 1] && !data.quickStop) {

            //if(this._randomStackedOverlayReels[data.reelId] || this._reelZeroDone) {

            if(this._isRandomStack) {
                if(this._reelZeroDone && (!attentionPlayed || this._delayedReels.length === 0)) {
                    this.playAttention(data, undefined, (this._quirkDelay) ? 0.35 : 0);
                    this._quirkDelay = false;
                } else {
                    this._reelZeroDone = false;
                    this._delayedReels.push(data);
                }

                //console.log("Delayed start of attention on reelId:" + this._delayedReel);
            } else {

                if(!this._randomStackedOverlayReels[data.reelId] && this._nearWinReels[data.reelId + 1]) {
                    this.playAttention(data, undefined, 0);
                    if(this._quirkDelay) {
                        this._quirkDelay = false;
                    }
                }
            }


            if(!this._soundPlaying && !this._isRandomStack) {
                SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.ANTICIPATION);
                this._soundPlaying = true;
            }
        }

        if(this._soundPlaying && data.reelId === 4 && this._nearWinReels[data.reelId]) {
            //EventHandler.dispatchEvent(new GameEvent(ReelAttentionEvent.REEL_ATTENTION_STOPPING, data.reelId));

            if(!this._isRandomStack && this._gameData!.nextMode === GameMode.FREESPIN) {
                SlotGame.sound.stopEffect(TractorBeamSoundConfig.instance.ANTICIPATION);
            } else if(!this._isRandomStack) {
                SlotGame.sound.stopEffect(TractorBeamSoundConfig.instance.ANTICIPATION);
                SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.ANTICIPATION_FAIL);
            }
        }

        if(this._soundPlaying && this._isRandomStack && data.reelId === this._lastSpinningReel) {
            if(this._totalWin <= 0 && !this._tractorData!.isBigWin) {
                SlotGame.sound.stopEffect(TractorBeamSoundConfig.instance.ANTICIPATION);
                SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.ANTICIPATION_FAIL);
            } else {
                SlotGame.sound.stopEffect(TractorBeamSoundConfig.instance.ANTICIPATION);
            }
        }

        TractorBeamGameModuleConfig.background.resetBeam(data.reelId);
        this.dispatchCompleteEvent(data.reelId);
    }

    public justPlayAttention(reelId:number):void {
        // Make sure to not play on conditions in play attention
        if(this._gameMode === GameMode.FREESPIN) {
            return;
        }


        if(!this._randomStackedOverlayReels[reelId] && this._nearWinReels[reelId]) {
            if(this._isRandomStack && reelId === 0) {
                this._isRunningOnStack = true;
                EventHandler.dispatchEvent(new GameEvent(ReelAttentionEvent.REEL_ATTENTION_PLAYING, reelId, this._tractorData!.randomStackedTriggered));
                if(!this._soundPlaying) {
                    SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.ANTICIPATION);
                    this._soundPlaying = true;
                }
            } else {
                if(!this._soundPlaying && this._isRandomStack) {
                    SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.ANTICIPATION);
                    this._soundPlaying = true;
                }
                EventHandler.dispatchEvent(new GameEvent(ReelAttentionEvent.REEL_ATTENTION_PLAYING, reelId, this._tractorData!.randomStackedTriggered, 0));
            }
        }
        return;

    }

    private playAttention(data:IReelStoppedData, fromSpinCont:boolean = false, delay:number = 0, fromStack:boolean = false):void {
        if(this._gameMode === GameMode.FREESPIN) {
            return;
        }
        if(data.quickStop) {
            return;
        }
        if(this._isRandomStack && data.reelId > 0 && !this._reelZeroDone) { // TODO: Remove
            return;
        }

        /*if(this._isRandomStack && (data.reelId + 1) === 4 && !fromStack) { // TODO: Remove
            return;
        }*/

        if(this._tractorData!.randomStackedTriggered && data.reelId === 0) {
            this._isRunningOnStack = true;
            EventHandler.dispatchEvent(new GameEvent(ReelAttentionEvent.REEL_ATTENTION_PLAYING, (fromSpinCont) ? data.reelId : data.reelId + 1, this._tractorData!.randomStackedTriggered));
            if(!this._soundPlaying) {
                SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.ANTICIPATION);
                this._soundPlaying = true;
            }
        } else {
            if(!this._soundPlaying && this._isRandomStack) {
                SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.ANTICIPATION);
                this._soundPlaying = true;
            }
            EventHandler.dispatchEvent(new GameEvent(ReelAttentionEvent.REEL_ATTENTION_PLAYING, data.reelId + 1, this._tractorData!.randomStackedTriggered, delay));
        }
        return;
    }
}
